import {QuranDetailModel} from './quran.model';

export const checkQuranSoreListIncludeSearchString = (
  array: QuranDetailModel[],
  searchText: string
): QuranDetailModel[] => {
  if (array) {
    let quranSoreList: QuranDetailModel[] = [];
    array.forEach((quranSore) => {
      if (quranSore.attributes.name.replace('ي', 'ی').replace('ك', 'ک').replace('إ', 'ا').includes(searchText)) {
        quranSoreList.push(quranSore);
      }
      return '';
    });
    return quranSoreList;
  }
  return [];
};
